import { render, staticRenderFns } from "./myshoucang.vue?vue&type=template&id=04f914cc&scoped=true"
var script = {}
import style0 from "./myshoucang.vue?vue&type=style&index=0&id=04f914cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f914cc",
  null
  
)

export default component.exports